import React from 'react'
import { usePageView } from '@fs/zion-analytics'
import { Route, Switch } from '@fs/zion-router'

import { africaSupportedCountryNames } from '../../../team-spaces/africa/africaCountries'

const ChineseLandingPages = React.lazy(
  () => import('../../../team-spaces/chinese-jade/ChineseLandingPages/ChineseLandingPages')
)
const AfricaNLIHP = React.lazy(() => import('../../../team-spaces/africa/AfricaNLIHP'))
const CanadaNLIHP = React.lazy(() => import('../../../team-spaces/north-america/NorthAmericaNLIHP/Canada'))
const UnitedStatesNLIHP = React.lazy(() => import('../../../team-spaces/north-america/NorthAmericaNLIHP/UnitedStates'))
const UnauthenticatedPage = React.lazy(
  () => import('../../../shared/components/UnauthenticatedPage/UnauthenticatedPage')
)

function UnauthenticatedPortalPage() {
  usePageView({ page_detail: 'Unauthenticated Portal Page' })
  return <UnauthenticatedPage />
}

export default function UnauthenticatedRoutes() {
  const chineseNlihpPaths = ':nlihp(chinese|hong-kong|macau|mainland-china|singapore|taiwan)'
  const africaNlihpPaths = `:country(${africaSupportedCountryNames.join('|')})`
  const localePath = '([a-z]{2,3}|[a-z]{2,3}-[a-zA-Z0-9-]*)?'

  return (
    <Switch>
      <Route path={`${localePath}/${chineseNlihpPaths}`} component={ChineseLandingPages} />
      <Route path={`${localePath}/${africaNlihpPaths}`} component={AfricaNLIHP} />
      <Route path={`${localePath}/canada`} component={CanadaNLIHP} />
      <Route path={`${localePath}/united-states`} component={UnitedStatesNLIHP} />
      <Route component={UnauthenticatedPortalPage} />
    </Switch>
  )
}
